import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { AcordoItem, FiltroAcordos } from "../typings";

function useAcordos(params: FiltroAcordos, enabled = true) {
  return useQuery(
    [`/v1/acordo`, params],
    async () => {
      const res = await axios.get<PaginateResult<AcordoItem>>(`/v1/acordo`, {
        params,
      });

      return res.data;
    },
    {
      enabled,
    }
  );
}

export default useAcordos;
